import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mapings = new Map<ProfiBazaAPIModels.StatementArea, string>([
	[ProfiBazaAPIModels.StatementArea.NPZ, 'NPZ'],
	[ProfiBazaAPIModels.StatementArea.MZ49, 'MZ-49'],
	[ProfiBazaAPIModels.StatementArea.MZ53, 'MZ-53'],
]);

export const map = (value: ProfiBazaAPIModels.StatementArea): string =>
	mapings.get(value) ?? value;